import { render } from "./InvitesView.vue?vue&type=template&id=8dff081e"
import script from "./InvitesView.vue?vue&type=script&lang=js"
export * from "./InvitesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__